export const imagePath = (id: string, preset: "portrait" | "landscape" | "cards" | "thumbnails" = "portrait", format: "webp" | "jpg" = "webp") =>
  `./assets/optimized/${preset}/${id}.${format}`;

export function pictureMarkup(id: string, alt: string, className = ""): string {
  return `<picture class="${className}">
    <source media="(orientation: landscape)" srcset="${imagePath(id, "landscape")}" type="image/webp">
    <source srcset="${imagePath(id, "portrait")}" type="image/webp">
    <img src="${imagePath(id, "portrait", "jpg")}" alt="${escapeHtml(alt)}" draggable="false">
  </picture>`;
}

export function preloadImage(id?: string): void {
  if (!id) return;
  const image = new Image();
  image.src = imagePath(id, matchMedia("(orientation: landscape)").matches ? "landscape" : "portrait");
}

export function escapeHtml(value: string): string {
  return value.replace(/[&<>'"]/g, (char) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", "'": "&#39;", '"': "&quot;" })[char]!);
}
